import { SvgIcon } from '@mui/material';

import type * as React from 'react';
import type { BaseIconProps } from '../types';

export const LongArrowPrevIcon: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 20 10" fillRule="evenodd" stroke="none" {...props}>
      <path
        d="M1 4L19 4C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5C20 5.26522 19.8946 5.51957 19.7071 5.70711C19.5196 5.89464 19.2652 6 19 6L1 6C0.734783 6 0.480429 5.89464 0.292892 5.7071C0.105356 5.51957 6.42368e-08 5.26521 8.74228e-08 5C1.10609e-07 4.73478 0.105356 4.48043 0.292893 4.29289C0.480429 4.10536 0.734783 4 1 4Z"
        fill="currentColor"
      />
      <path
        d="M5 0.00372115C5.13161 0.00296013 5.26207 0.0281848 5.38391 0.0779495C5.50575 0.127714 5.61656 0.201041 5.71 0.293722C5.80373 0.386685 5.87812 0.497285 5.92889 0.619144C5.97966 0.741004 6.0058 0.87171 6.0058 1.00372C6.0058 1.13573 5.97966 1.26644 5.92889 1.3883C5.87812 1.51016 5.80373 1.62076 5.71 1.71372L2.41 5.00372L5.71 8.29372C5.8983 8.48202 6.00409 8.73742 6.00409 9.00372C6.00409 9.27002 5.8983 9.52542 5.71 9.71372C5.5217 9.90202 5.2663 10.0078 5 10.0078C4.7337 10.0078 4.4783 9.90202 4.29 9.71372L0.290001 5.71372C0.196273 5.62076 0.121877 5.51016 0.0711083 5.3883C0.0203394 5.26644 -0.00579791 5.13573 -0.0057979 5.00372C-0.00579789 4.87171 0.0203395 4.741 0.0711083 4.61914C0.121877 4.49728 0.196273 4.38668 0.290001 4.29372L4.29 0.293722C4.38344 0.201041 4.49426 0.127714 4.61609 0.0779494C4.73793 0.0281848 4.86839 0.00296011 5 0.00372115Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
